export default "/images/642af38a1eec5b68b96e9218db561e72.avif";